module.exports = __webpack_public_path__ + "static/media/newsletter-september-2018-camp.d6bcb59f.png";